import SwiperCore, { Navigation, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import classes from "./index.module.scss";
import { v4 as uuid } from "uuid";

SwiperCore.use([Navigation, Autoplay]);

export default function Carousel({ images, currentSlide, handleClose }) {
  return (
    <div className={classes.carousel}>
      <button onClick={handleClose} className={classes.close}>
        Close
      </button>
      <Swiper
        slidesPerView={1.75}
        centeredSlides={true}
        spaceBetween={16}
        watchOverflow
        loop={true}
        lazy={true}
        loadPrevNext={true}
        loadPrevNextAmount={2}
        grabCursor={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          768: {
            slidesPerView: 1.5,
          },
          1280: {
            slidesPerView: 1.75,
          },
          1560: {
            slidesPerView: 2.5,
          },
          2200: {
            slidesPerView: 3.5,
          },
          3100: {
            slidesPerView: 4.5,
          },
          4000: {
            slidesPerView: 5.75,
          },

          5000: {
            slidesPerView: 6.5,
          },
        }}
        navigation={true}
        modules={[Navigation, Autoplay]}
        className={classes.swiper}
        initialSlide={currentSlide}
      >
        {images?.map(({ images: { webp, png } }) => (
          <SwiperSlide key={uuid()}>
            <picture>
              <source srcSet={webp} type="image/webp" />
              <img src={png} alt="history" width={331} height={214} />
            </picture>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
